<template>
  <NotificationWrapper />
</template>

<script>
export default {
  name: "NotificationsPage",
  components: {
    NotificationWrapper: () => import("@/components/ri3/notifications/NotificationWrapper.vue")
  }
}
</script>
